<template>
    <div :class="className">

        <slot name="prev" :value="inputValue" :checked="enabled"></slot>
        <vue-switch
            theme="bootstrap"
            :color="color"
            :type-bold="true"
            v-model="enabled"
            class="float-left"
        />
        <slot name="next" :value="inputValue" :checked="enabled"></slot>
        <div style="display: none;">
            <slot name="hidden" :value="inputValue" :checked="enabled"></slot>
        </div>

    </div>
</template>

<script>
    import Switches from './widget/Switches';

    import mixinInput from './mixinInput';

    export default {
        mixins: [ mixinInput ],
        components: {
            'vue-switch': Switches
        },
        props: {
            name: {
                type: String,
                default: ''
            },
            className: {
                type: String,
                default: ''
            },
            color: {
                type: String,
                default: 'primary'
            },

            checkedValue: {
                type: [String, Number],
                default: 1
            },
            uncheckedValue: {
                type: [String, Number],
                default: 0
            }
        },
        data() {
            return {

            };
        },
        computed: {
            enabled: {
                get() {
                    return this.inputValue === 'string' ? !!+this.inputValue.trim() : !!+this.inputValue;
                },
                set( enabled ) {
                    this.inputValue = enabled ? '1' : '';
                }
            }
        },
        mounted() {

        }
    }
</script>
